(() => {
  const q = (root, selector) => root.querySelector(selector);

  function findMainBuyButton() {
    const mainProduct = document.querySelector('product-info[id^="MainProduct-"]');
    if (!mainProduct) return null;
    return mainProduct.querySelector('product-form .product-form__submit, form[id^="product-form-"] .product-form__submit');
  }

  function updateStickyVisibility() {
    const sticky = document.querySelector('[data-nw-sticky-atc]');
    const buyButton = findMainBuyButton();
    if (!sticky || !buyButton) return;
    const rect = buyButton.getBoundingClientRect();
    const shouldShow = rect.bottom < 0;
    sticky.classList.toggle('is-visible', shouldShow);
    document.body.classList.toggle('nw-sticky-atc-visible', shouldShow);
  }

  let ticking = false;
  function requestStickyUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateStickyVisibility();
      ticking = false;
    });
  }

  function syncStickyPrice() {
    const stickyPrice = document.querySelector('[data-nw-sticky-price]');
    if (!stickyPrice) return;
    const mainProduct = document.querySelector('product-info[id^="MainProduct-"]');
    if (!mainProduct) return;
    const priceNode = mainProduct.querySelector('.price .price-item--sale, .price .price-item--regular');
    if (priceNode && priceNode.textContent.trim()) stickyPrice.textContent = priceNode.textContent.trim();
  }

  function getSelectedPurchaseOption(group) {
    return group?.querySelector('.nw-purchase-radio:checked') || null;
  }

  function getProductForm(group) {
    if (!group) return null;
    const id = group.dataset.productFormId;
    return id ? document.getElementById(id) : null;
  }

  function syncPurchaseGroup(group) {
    if (!group) return;
    const selected = getSelectedPurchaseOption(group);

    group.querySelectorAll('.nw-purchase-radio').forEach((radio) => {
      const label = radio.id ? group.querySelector(`label[for="${CSS.escape(radio.id)}"]`) : null;
      if (label) label.classList.toggle('is-selected', radio.checked);
    });

    const form = getProductForm(group);
    if (!form) return;

    // Remove only the hidden field managed by this theme. Other subscription
    // app fields are left in the DOM, then sanitized in the formdata event.
    form.querySelectorAll('[data-nw-managed-selling-plan]').forEach((input) => input.remove());

    if (selected?.value === 'subscription') {
      const planId = selected.dataset.sellingPlanId;
      if (planId) {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'selling_plan';
        hidden.value = planId;
        hidden.setAttribute('data-nw-managed-selling-plan', '');
        form.appendChild(hidden);
      }
    }
  }

  function attachFormSanitizer(group) {
    const form = getProductForm(group);
    if (!form || form.dataset.nwPurchaseSanitizer === 'true') return;
    form.dataset.nwPurchaseSanitizer = 'true';

    // Dawn builds FormData from the product form. This hook guarantees that
    // one-time purchase contains NO selling_plan, even if a subscription app
    // embed injected its own field. Subscription mode gets exactly one plan.
    form.addEventListener('formdata', (event) => {
      const activeGroup = document.querySelector(`[data-nw-purchase-options][data-product-form-id="${CSS.escape(form.id)}"]`);
      const selected = getSelectedPurchaseOption(activeGroup);
      event.formData.delete('selling_plan');
      if (selected?.value === 'subscription') {
        const planId = selected.dataset.sellingPlanId;
        if (planId) event.formData.set('selling_plan', planId);
      }
    });
  }

  function setupPurchaseOptions(root = document) {
    root.querySelectorAll('[data-nw-purchase-options]').forEach((group) => {
      syncPurchaseGroup(group);
      attachFormSanitizer(group);
    });
  }

  // Use the native radio/label interaction. The explicit for/id relationship
  // makes both cards clickable without depending on JavaScript click hacks.
  document.addEventListener('change', (event) => {
    if (event.target.matches('.nw-purchase-radio')) {
      syncPurchaseGroup(event.target.closest('[data-nw-purchase-options]'));
    }
    if (event.target.closest('product-info')) setTimeout(syncStickyPrice, 80);
  });

  document.addEventListener('click', (event) => {
    const stickyButton = event.target.closest('[data-nw-sticky-submit]');
    if (!stickyButton) return;
    event.preventDefault();
    const buyButton = findMainBuyButton();
    if (!buyButton || buyButton.disabled) return;
    buyButton.click();
  });

  document.addEventListener('DOMContentLoaded', () => {
    updateStickyVisibility();
    syncStickyPrice();
    setupPurchaseOptions();
  });

  document.addEventListener('shopify:section:load', (event) => {
    updateStickyVisibility();
    syncStickyPrice();
    setupPurchaseOptions(event.target);
  });

  document.addEventListener('product-info:loaded', (event) => setupPurchaseOptions(event.target));

  // ProductInfo can replace its inner HTML when variants change. Rebind the
  // purchase controls after any such DOM replacement.
  const observer = new MutationObserver((mutations) => {
    if (mutations.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.('[data-nw-purchase-options]') || n.querySelector?.('[data-nw-purchase-options]'))))) {
      setupPurchaseOptions();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('scroll', requestStickyUpdate, { passive: true });
  window.addEventListener('resize', requestStickyUpdate, { passive: true });
})();
